import { render, staticRenderFns } from "./ConfirmFuneralHandover.vue?vue&type=template&id=1db9851e"
import script from "./ConfirmFuneralHandover.vue?vue&type=script&lang=js"
export * from "./ConfirmFuneralHandover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports